//-------------------- Dashboard EndPoints ------------------------//
export const API_GET_MAX_USER_DATA = "Dashboard/GetMaxUserGraph";
export const API_GET_ASPEN_GRAPH = "Dashboard/GetAspenGraphData";

//-------------------- ServiceInfo EndPoints ------------------------//
export const API_GET_SERVER_INFO = "ServerInfo";
export const API_GET_SERVERS = "ServerInfo/ServersByGroup";
export const API_SET_NEW_INSTANCE = "ServerInfo/NewInstance";

//-------------------- Alert EndPoints ------------------------//
export const API_GET_SERVER_ALERT = "ServerInfo/ServerAlerts";
export const API_GET_CSI_ALERT = "ServerInfo/CsiAlerts";
export const API_GET_ASPEN_ALERT = "Customer/AspenAlerts";
export const API_GET_IDEAL_CUSTOMER_ALERT = "IdealCustomers/IdealAlerts";
export const API_ACKNOWLEDGE_IDEAL_ALERT = "IdealCustomers/AckIdealAlert";
export const API_GET_ASPEN_ANONYMOUS_USER_ALERT =
  "ServerInfo/GetAspenAnonymousUserAlert";

//-------------------- Customer EndPoints ------------------------//
export const API_CUT_OFF_DEALER = "Customer/CutOffDealer/";

//-------------------- Availablity EndPoints ------------------------//
export const API_GET_INFINITY_UPTIME = "Availability/InfinityUptime";
export const API_GET_UERS_COST = "Availability/GetUserCost";

//-------------------- Communication EndPoints ------------------------//
export const API_GET_HOST_POOL = "Communication/GetHostPool";
export const API_GET_SESSION_HOST = "Communication/GetSessionHost/";
export const API_GET_USER_SESSION = "Communication/GetUserSession";
export const API_NOTIFY_USER = "Communication/NotifyUser";

//-------------------- Errors EndPoints ------------------------//
export const API_GET_ASPEN_DB_LOGS = "Communication/GetAspenError";
